export default __webpack_public_path__ + "static/media/blue-line-background.3f325d1a.png";